import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface WrapperPropsType {
  variant: DefaultComponentVariantType | null;
}

export const Wrapper = withConfig(theme => styled('div', { label: 'Wrapper' })<WrapperPropsType>`
    background-color: ${({variant = null}) => variant === DefaultComponentVariantType.TERTIARY ? theme.star.unified.layoutGlobal.bgColor : theme.star.layoutGlobal.bgColor};
    height: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'auto': '100%'};
`);

export const Event = styled('div', { label: 'Event' })`
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 0%;
    min-height: 100%;
`;
